import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hui from 'hui';
import api from 'axios';
import { memoize } from 'lodash';

const CategorySiteAutocomplete = hui.CategorySiteAutocomplete;
const fetchSuggestions = memoize(query => api.get('/system/ajax_handlers/vtk.ac.search.category.and.site.server.json.php', { params: { query } }));

export default class CategorySiteSearch extends Component {

  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    placeholder: PropTypes.string
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'category-site-search',
    placeholder: `I'm looking for... (e.g Plumber)`
  };

  state = {
    category: {}
  };

  onChange = (category) => {
    this.setState({ category });
  };

  render() {
    const { category } = this.state;
    return (<CategorySiteAutocomplete
      id="category-site-search"
      name={this.props.name}
      classPrefix={this.props.classPrefix}
      value={category.name}
      data-placeholder={this.props.placeholder}
      placeholder={this.props.placeholder}
      onChange={this.onChange}
      fetchSuggestions={fetchSuggestions}
    />);
  }
}



// WEBPACK FOOTER //
// ./header/scripts/components/category-site-search.js